import { Progress } from 'antd'
import React from 'react'
import Button from '../../shared/Button'
import send from "../../../assets/img/icons/green-send.svg"
const CreateProgreaabar = ({page =16,currentpage=1,title}) => {
  return (
    <div className='CreateProgreaabar'>
       <div className='flex justify-between items-center mb-[24px]'>
       <div>
       <h2>{title}</h2>
        <p>صفحه {currentpage} از {page} صفحه در حال تکمیل است</p>
       </div>
       <Button varient="white"> <div className='flex gap-[5px]'>
       <div>ذخیره سازی و خروج</div>
       
  <img src={send}/>
       </div>
       </Button>
       </div>
            <Progress percent={currentpage/page * 100} strokeWidth={16} strokeColor="#00A6A6" trailColor="#D0D5D7"  showInfo={false} />

    </div>
  )
}

export default CreateProgreaabar